import { Menu } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { logInfo } from 'utils/logUtils'

const useStyles = makeStyles(theme => ({
  root: {
    padding: 0,
    boxShadow: '0px 4px 30px rgba(0, 0, 0, 0.15)',
    zIndex: 9999
  },
  list: {
    padding: 0
  }
}))

const GrinMenu = ({
  id = '',
  children,
  onClose,
  transformOrigin,
  className = '',
  triggerComponent,
  triggerWrapperStyle = {},
  anchorOrigin,
  onOpen,
  open,
  disableMenuFocus = false,
  disableCloseOnBackdropClick = false,
  disabled = false,
  customAnchorEl,
  keepMounted = true,
  onFocus = () => {}
}) => {
  const classes = useStyles()

  const [anchorEl, setAnchorEl] = useState(null)

  const isOpen = useMemo(() => open && Boolean(anchorEl), [anchorEl, open])

  const handleClose = useCallback(
    (e, reason) => {
      if (disableCloseOnBackdropClick && reason === 'backdropClick') {
        return
      }

      logInfo('[GrinMenu] Menu closing', {
        component: 'GrinMenu',
        event: 'menu_close',
        reason,
        menuId: id
      })

      setAnchorEl(null)

      if (onClose) {
        onClose(e, reason)
      }
    },
    [disableCloseOnBackdropClick, onClose, id]
  )

  const handleOpen = useCallback(
    e => {
      if (disabled) {
        return
      }

      logInfo('[GrinMenu] Menu opening', {
        component: 'GrinMenu',
        event: 'menu_open',
        menuId: id,
        hasCustomAnchor: !!customAnchorEl
      })

      setAnchorEl(customAnchorEl || e.currentTarget)
      if (onOpen) {
        onOpen(e)
      }
    },
    [onOpen, disabled, customAnchorEl, id]
  )

  useEffect(() => {
    setAnchorEl(customAnchorEl)
  }, [customAnchorEl])

  return (
    <>
      <span id={id} onClick={handleOpen} style={{ display: 'inline-block', ...triggerWrapperStyle }}>
        {triggerComponent}
      </span>
      <Menu
        anchorEl={anchorEl}
        keepMounted={keepMounted}
        open={isOpen}
        disableEnforceFocus={disableMenuFocus}
        onClose={handleClose}
        classes={{
          paper: [classes.root, className].join(' '),
          list: classes.list
        }}
        transformOrigin={transformOrigin}
        anchorOrigin={anchorOrigin}
        getContentAnchorEl={null}
        onFocus={onFocus}
      >
        {isOpen && <div>{children}</div>}
      </Menu>
    </>
  )
}

export default GrinMenu
